import React from 'react';
import { ButtonLarge } from './ButtonLarge/ButtonLarge';
import './ButtonGroup/ButtonGroup.css';

const ButtonGroup = ({ buttons = [] }) => {
  return (
    <div style={{
      display: 'flex',
      gap: '4px',
      width: '100%',
      maxWidth: '343px',
      margin: '0 auto',
    }}>
      {buttons.map((button, index) => (
        <ButtonLarge
          key={index}
          text={button.text}
          buttonLargeClassName={`button-large ${button.buttonLargeClassName}`}
          style={{
            minWidth: '0',
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onClick={button.onClick}
        />
      ))}
    </div>
  );
};

export default ButtonGroup;
